<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de paciente atendido">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/farmacia/relatorio-paciente-atendido/List'

export default {
    components: {
        List,
    },
}
</script>